import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getReturnList = createAsyncThunk(
  "get-return",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("return/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createReturn = createAsyncThunk(
  "create-return",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("return", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getByIdReturn = createAsyncThunk(
  "edit-return",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`return/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateReturn = createAsyncThunk(
  "update-return",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/return/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteReturn = createAsyncThunk(
  "delete-return",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/return/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const downloadReturn = createAsyncThunk(
  "download-return",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`return/download/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const returnSlice = createSlice({
  name: "return",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReturnList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReturnList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.returnList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getReturnList.rejected, (state) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default returnSlice.reducer;
